'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H3 = exports.H2 = exports.H1 = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  font-size: ', ';\n'], ['\n  ', '\n  font-size: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var commonStyle = function commonStyle(theme) {
  return '\n  padding: 0;\n  margin: 0;\n  color: ' + theme.color.textColor + ';\n  font-weight: ' + theme.heading.fontWeight + ';\n  font-family: ' + theme.heading.fontFamily + ';\n  line-height: ' + theme.heading.lineHeight + ';\n';
};

var H1 = exports.H1 = _styledComponents2.default.h1(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return commonStyle(theme);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.heading.fontSize.h1;
});

var H2 = exports.H2 = _styledComponents2.default.h2(_templateObject, function (_ref3) {
  var theme = _ref3.theme;
  return commonStyle(theme);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.heading.fontSize.h2;
});

var H3 = exports.H3 = _styledComponents2.default.h3(_templateObject, function (_ref5) {
  var theme = _ref5.theme;
  return commonStyle(theme);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.heading.fontSize.h3;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Heading/Heading.js
// module id = 176
// module chunks = 1